// ── Theme index ─────────────────────────────────────
// Re-exports the same public API as the old monolithic themes.ts.
// Each theme is a standalone config file in this directory.

export type { ThemeDefinition } from "./types";
export { hexToLinear, hexToSrgb } from "./palette";

import type { ThemeDefinition } from "./types";

import { abyss } from "./abyss";
import { arctic } from "./arctic";
import { basalt } from "./basalt";
import { chalk } from "./chalk";
import { cobalt } from "./cobalt";
import { darkula } from "./darkula";
import { daylight } from "./daylight";
import { depths } from "./depths";
import { driftwood } from "./driftwood";
import { dune } from "./dune";
import { foam } from "./foam";
import { gruvbox } from "./gruvbox";
import { pacific } from "./pacific";
import { parchment } from "./parchment";
import { reef } from "./reef";
import { salt } from "./salt";
import { sepia } from "./sepia";
import { shoal } from "./shoal";
import { soot } from "./soot";
import { timber } from "./timber";

export const THEMES: Record<string, ThemeDefinition> = {
  abyss,
  arctic,
  basalt,
  chalk,
  cobalt,
  darkula,
  daylight,
  depths,
  driftwood,
  dune,
  foam,
  gruvbox,
  pacific,
  parchment,
  reef,
  salt,
  sepia,
  shoal,
  soot,
  timber,
};

export type ThemeName = keyof typeof THEMES;
export const THEME_NAMES = Object.keys(THEMES) as ThemeName[];
export const DEFAULT_THEME: ThemeName = "reef";

/** Valid theme names for DB-side validation. */
export const VALID_THEMES: string[] = [...THEME_NAMES];

/** Migrate old localStorage values to new theme names. */
export function migrateThemeName(stored: string | null): ThemeName {
  if (!stored) return DEFAULT_THEME;
  if (stored === "dark") return "abyss";
  if (stored === "light") return "daylight";
  if (stored === "dracula") return "darkula";
  if (stored === "mist") return "reef";
  if (stored in THEMES) return stored as ThemeName;
  return DEFAULT_THEME;
}
